<template>
  <div class="app-container">
    <div class="app-content">
      <div class="split-flex">
        <div class="flex-left">
          <el-form ref="query" :model="query">
            <el-form-item label="用户名">
              <el-input v-model="query.name" clearable placeholder="请输入用户名" />
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="query.phone" clearable placeholder="请输入手机号" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">
                搜索
              </el-button>
              <el-button @click="onReset">
                重置
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="flex-right">
          <transition name="slide-fade">
            <component :is="currentPage"
                       ref="userComponent"
                       :page-props="$props"
                       :params="q"
                       :route.sync="r"
                       :pid="p"
                       @setRPQ="setRPQ" />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import userAdd from './user-add.vue';
import userList from './user-list.vue';
import userDetail from './user-detail.vue';
import { queryUserGroup } from '@/api/admin';

export default {
  name: 'PageUserManagement',
  title: '页面-用户管理',
  components: {
    userAdd,
    userList,
    userDetail,
  },
  data() {
    return {
      query: {},
      r: 'list', // 页面路由，r=
      p: undefined, // id路由，p=
      q: {}, // query查询条件参数，不放入url
      groups: [],
    };
  },
  computed: {
    currentPage() {
      return `user-${this.r || 'list'}`;
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.query': function (val) {
      if (val.r) {
        this.r = val.r;
      }
      if (val.p) {
        this.p = val.p;
      }
    },
  },
  created() {
    this.setRPQ({ r: this.$route.query.r, p: this.$route.query.p });
  },
  methods: {
    onSubmit() {
      this.setRPQ({ r: 'list', p: undefined });
      this.q = this.query;
      this.$nextTick(() => {
        this.$refs.userComponent.fetchData();
      });
    },
    onReset() {
      this.query = {};
      this.onSubmit();
    },
    setRPQ({ r, p, q }) {
      console.log(r, p, q);
      this.r = r;
      this.p = p;
      if (q) {
        this.q = q;
      }
      this.$router.replace({ query: Object.assign({}, this.$route.query, { r, p }) });
    },
  },
};
</script>
